module.exports = __webpack_public_path__ + "d1c4094a1acc6bff30f01df99e3f978a.pdf";